import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreventClickDirective } from './prevent-click.directive';



@NgModule({
  declarations: [
    PreventClickDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    PreventClickDirective
  ]
})
export class PreventClickModule { }
